import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from './globalAction';
import { setDataCombo } from './comboAction';
import { setDataDataNonPrioritass } from '../action/dataNonPrioritasAction';

export const setDataDataPrioritass = (Year=null) => {
    return (dispatch) => {
        var Session = JSON.parse(localStorage.getItem("SessionLogin"));
        var isAgency = false;
        Session?.Roles.map((item, index) => {
            if(item.IdRole == 2 || item.IdRole == 4){
                isAgency = false;
            } else {
                isAgency = true;
            }
        })
        if(isAgency){
            var URL = `${URLSVC}/Admins/GetMetadatas?Year=${Year}&AgencyCode=${Session?.Agency.Code}`;
        } else {
            var URL = `${URLSVC}/Admins/GetMetadatas?Year=${Year}`;
        }

        http.get(URL).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                var Datas = [];
                data.Data.map((item, index) => {
                    if(item.Priority == "Priority"){
                        Datas.push(item);
                    }
                })
                dispatch({type: 'DATA_PRIORITASS', payload: Datas})
            } else {
                dispatch({type: 'DATA_PRIORITASS', payload: data })
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataDataPrioritas = (Id,SetStatus=true) => {
    return (dispatch) => {
        loadingBar(true);
        dispatch({type: 'RESET_FORM_DATA_PRIORITAS'})
        var Url = `${URLSVC}/Admins/GetMetadata?Id=${Id}`;
        http.get(Url).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({ type: 'DATA_PRIORITAS', payload: data.Data })
                const SELECT = {
                    License: {
                        value: data.Data.License.Id,
                        label: data.Data.License.Name
                    },
                    DataScope: {
                        value: data.Data.DataScope.Id,
                        label: data.Data.DataScope.Name
                    },
                    Frequency: {
                        value: data.Data.Frequency.Id,
                        label: data.Data.Frequency.Name
                    },
                    Agency: {
                        value: data.Data.Agency.Id,
                        label: data.Data.Agency.Name
                    },
                    DatasetCategory: {
                        value: data.Data.DatasetCategory.Id,
                        label: data.Data.DatasetCategory.Name
                    },
                    DatasetType: {
                        value: data.Data.DatasetType.Id,
                        label: data.Data.DatasetType.Name
                    },
                    Year: {
                        value: data.Data.Year,
                        label: data.Data.Year
                    },
                    Affair: {
                        value: data.Data.Affair?.Id,
                        label: data.Data.Affair?.Name
                    },
                    Sector: {
                        value: data.Data.Sector?.Id,
                        label: data.Data.Sector?.Name
                    },
                    PublicationType: {
                        value: data.Data.PublicationType?.Id,
                        label: data.Data.PublicationType?.Name
                    }
                };
                if(SetStatus){
                    dispatch(setFormDataPrioritas('Status', data.Data.Status))
                } else {
                    dispatch(setFormDataPrioritas('Status', "New"))
                }
                dispatch(setFormDataPrioritas('License', SELECT.License))
                dispatch(setFormDataPrioritas('DataScope', SELECT.DataScope))
                dispatch(setFormDataPrioritas('Frequency', SELECT.Frequency))
                dispatch(setFormDataPrioritas('Agency', SELECT.Agency))
                dispatch(setFormDataPrioritas('DatasetCategory', SELECT.DatasetCategory))
                dispatch(setFormDataPrioritas('DatasetType', SELECT.DatasetType))
                dispatch(setFormDataPrioritas('Id', data.Data.Id))
                dispatch(setFormDataPrioritas('PublicationType', SELECT.PublicationType))
                dispatch(setFormDataPrioritas('IsPriority', data.Data.IsPriority))
                dispatch(setFormDataPrioritas('Name', data.Data.Name))
                dispatch(setFormDataPrioritas('Year', SELECT.Year))
                dispatch(setFormDataPrioritas('DataSource', data.Data.DataSource))
                dispatch(setFormDataPrioritas('Title', data.Data.Title))
                dispatch(setFormDataPrioritas('Description', data.Data.Description))
                dispatch(setFormDataPrioritas('FileUpload', data.Data.FileUpload))

                dispatch(setFormDataPrioritas('Atributes', data.Data.Atributes))
                //dispatch(setFormDataPrioritas('TagIds', data.Data.TagIds))

                const Tags = [];
                const TagIds = [];
                data.Data.Tags.map((item, index) => {
                    TagIds.push(item.Name);
                    Tags.push({value:item.Id,label:item.Name}); 
                })
                dispatch(setFormDataPrioritas('Tags', Tags))
                dispatch(setFormDataPrioritas('TagIds', TagIds))

                dispatch(setFormDataPrioritas('IsSectoralData', data.Data.IsSectoralData))
                if(data.Data.IsSectoralData){
                    dispatch(setFormDataPrioritas('Affair', SELECT.Affair))
                    dispatch(setFormDataPrioritas('Sector', SELECT.Sector))
                }

                dispatch({type: 'MODAL_DATA_PRIORITAS', payload: true})
                
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setFormDataPrioritas = (formType, formValue) => {
    return {type: 'FORM_DATA_PRIORITAS', formType, formValue}
}

export const apiAddUpdateDataPrioritas = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        console.log("idata",iData);
        var fd = new FormData();
        var URL = ``;
        if(iData.Id == null || iData.Id == undefined || iData.Id == ""){
            URL = `${URLSVC}/Admins/SaveMetadata`;
        } else {
            if(iData.IsOldTemplate == "true"){
                URL = `${URLSVC}/Admins/SaveMetadata`;
            } else {
                fd.append('Id', iData.Id);
                URL = `${URLSVC}/Admins/SaveEditMetadata`;
            }
        }
        fd.append('Name', iData.Name);
        fd.append('Year', iData.Year.value);
        fd.append('LicenseId', iData.LicenseId.value);
        fd.append('DataScopeId', iData.DataScopeId.value);
        fd.append('DataSource', iData.DataSource);
        fd.append('FrequencyId', iData.FrequencyId.value);

        if(iData.SelectTagIds != undefined){
            if((iData.SelectTagIds).length > 0){
                iData.SelectTagIds.map((item, index) => {
                    fd.append(`TagIds[${index}]`, item.value);
                })
            }
        }
        
        fd.append('Title', iData.Title);
        fd.append('Description', iData.Description);
        fd.append('AgencyId', iData.AgencyId.value);
        fd.append('DatasetCategoryId', iData.DatasetCategoryId.value);
        fd.append('DatasetTypeid', iData.DatasetTypeid.value);
        fd.append('FileUpload', iData.FileUpload[0]);
        fd.append('PublicationType', iData.PublicationType.value);
        fd.append('IsPriority', true);
        
        if(iData.DataAttributes !== undefined && iData.DataAttributes.length > 0){
            iData.DataAttributes.map((item, index) => {
                if(item.Name != ""){
                    fd.append(`Atributes[${index}].Name`, item.Name);
                    fd.append(`Atributes[${index}].Title`, item.Name);
                    fd.append(`Atributes[${index}].FieldTypeId`, item.FieldTypeId.value);
                    if(iData.isSektoralData){
                        fd.append(`Atributes[${index}].ReferenceCodeTablesId`, item.FieldLength?.value);
                    } else {
                        if(parseInt(item.FieldTypeId.value) == 8){
                            fd.append(`Atributes[${index}].ReferenceCodeTablesId`, item.FieldLength?.value);
                        } else {
                            fd.append(`Atributes[${index}].FieldLength`, item.FieldLength);
                        }
                    }
                    fd.append(`Atributes[${index}].PublicationType`, item.PublicationType?.value);
                    fd.append(`Atributes[${index}].Description`, item.Description);
                }
            })
        }

        fd.append('IsSectoralData', iData.isSektoralData);
        if(iData.isSektoralData){
            fd.append('SectorId', iData.SectorId?.value);
        }
        
        http.post(URL,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil menyimpan metadata`, 'success');
                dispatch({ type: 'MODAL_DATA_PRIORITAS', payload: false })
                reset();
                dispatch(setDataDataPrioritass(iData.Year.value))
            } else {
                //dispatch({ type: 'MODAL_DATA_PRIORITAS', payload: false })
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiSaveTag = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        var fd = new FormData();
        fd.append('Name', iData.Name);
    
        http.post(`${URLSVC}/Admins/SaveTag`,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil menyimpan tag`, 'success');
                dispatch(setDataCombo('DATA_COMBO_TAG'))
                dispatch({ type: 'SET_IS_NEW_TAG', payload: false })
                reset()
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiDeleteDataPrioritas = (Id, Nama, Year) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menghapus data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/DeleteMetadata`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menghapus data (${Nama})`, 'success')
                        dispatch(setDataDataPrioritass(Year))
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiApproveDataPrioritas = (Id, Nama, Year) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menyetujui data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/ApproveMetadata`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menyetujui data (${Nama})`, 'success')
                        dispatch(setDataDataPrioritass(Year))
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiDeActivateDataPrioritas = (Id, Nama, Year, IsPriority) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menon-aktifkan data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/SetNonActiveDataset`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menon-aktifkan data (${Nama})`, 'success')

                        if(IsPriority == "Priority"){
                            dispatch(setDataDataPrioritass(Year))
                        } else {
                            dispatch(setDataDataNonPrioritass(Year))
                        }
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiActivateDataPrioritas = (Id, Nama, Year, IsPriority) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan meng-aktifkan data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/SetActiveMetadata`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil meng-aktifkan data (${Nama})`, 'success')
                        if(IsPriority == "Priority"){
                            dispatch(setDataDataPrioritass(Year))
                        } else {
                            dispatch(setDataDataNonPrioritass(Year))
                        }
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

